import { NgModule } from '@angular/core';
import { ChecklistReportViewModule } from './view/checklist-report-view.module';
import { ChecklistReportService } from './checklist-report.service';
import { CommonModule } from '@angular/common';
import { ChecklistReportListModule } from './list/checklist-report-list.module';
import { ChecklistReportHelperService } from './checklist-report-helper.service';
import { UIRouterModule } from '@uirouter/angular';
import { ChecklistReportStates } from '@fi-app/checklist-report/checklist-report-states';

@NgModule({
    imports: [
        CommonModule,
        ChecklistReportViewModule,
        ChecklistReportListModule,
        UIRouterModule.forChild(ChecklistReportStates),
    ],
    exports: [ChecklistReportViewModule],
    providers: [ChecklistReportService, ChecklistReportHelperService],
    declarations: [],
})
export class ChecklistReportModule {}
